import i18n from '@/main';
import http from '@/utils/http';
import axios from 'axios';

const URL_BASE = '/contrato-originacao/empresa';

export default {
    buscarContratosNaoEnviados({ pagina, ordenacao, tamanho }) {
        return http.get({
            url:
                URL_BASE +
                `/nao-enviados?page=${
                    pagina - 1
                }&sort=${ordenacao}&size=${tamanho}`,
            lockScreen: false
        });
    },

    buscarContratoOriginacao(id) {
        return http.get({
            url: URL_BASE + '/visualizar/' + id,
            lockScreen: true
        });
    },

    buscarContratoOriginacaoPY(id) {
        return http.get({
            url: URL_BASE + '/paraguai/visualizar/' + id,
            lockScreen: true
        });
    },

    buscarContratoOriginacaoAR(id) {
        return http.get({
            url: URL_BASE + '/argentina/visualizar/' + id,
            lockScreen: true
        });
    },

    buscarTerritoriosPreencherContratoAR({ contrato, pagina, tamanho }) {
        return http.get({
            url: URL_BASE + `/AR/${contrato}?page=${pagina}&size=${tamanho}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTerritorios')
        });
    },

    buscarStatus() {
        return http.get({
            url: URL_BASE + '/status',
            lockScreen: false
        });
    },

    cadastrarManualmentePY(data) {
        return http.post({
            url: URL_BASE + '/inserir/paraguai',
            data,
            lockScreen: false
        });
    },

    cadastrarManualmenteAR(payload) {
        return http.post({
            url: `${URL_BASE}/ar/inserir`,
            data: { ...payload },
            lockScreen: false
        });
    },

    cadastrarManualmente(payload) {
        return http.post({
            url: `${URL_BASE}/inserir`,
            data: { ...payload },
            lockScreen: false
        });
    },

    cadastrarViaPlanilha(planilha, ambiente) {
        const url =
            ambiente === 'PY'
                ? process.env.VUE_APP_HTTP_PATH +
                  URL_BASE +
                  '/inserir-planilha-paraguai'
                : process.env.VUE_APP_HTTP_PATH +
                  URL_BASE +
                  '/inserir-planilha';

        const formData = new FormData();
        formData.append('planilha', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    uploadPlanilhaVerificacao(planilha) {
        const url =
            process.env.VUE_APP_HTTP_PATH +
            '/arquivoVerificacaoTerritorios/upload';

        const formData = new FormData();
        formData.append('file', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    buscarHistoricoRecebimentos(pagina, tamanho) {
        return http.get({
            url: `/arquivoVerificacaoTerritorios/buscarDados?page=${pagina}&size=${tamanho}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.buscandoHistoricoRecebimentos'
            )
        });
    },

    removerContratoLote(idsContratosOriginacao) {
        return http.put({
            url: URL_BASE + `/remover-lote`,
            data: { idsContratosOriginacao },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.removendoContratos')
        });
    },

    removerContratoLoteArgentina(idsContratosOriginacao) {
        return http.put({
            url: URL_BASE + `/argentina/remover-lote`,
            data: { idsContratosOriginacao },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.removendoContratos')
        });
    },

    arquivarContrato(idsContratosOriginacao) {
        return http.put({
            url: URL_BASE + `/arquivar`,
            data: { idsContratosOriginacao },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.arquivandoContratos')
        });
    },

    cancelarContrato(idsContratosOriginacao) {
        return http.put({
            url: URL_BASE + `/cancelar`,
            data: { idsContratosOriginacao },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.cancelandoContrato')
        });
    },

    enviarContratos() {
        return http.get({
            url: URL_BASE + '/enviar-contratos',
            lockScreen: true
        });
    },

    exportarRelatorioContratoEmpresa(numeroContrato) {
        return http.get({
            url: URL_BASE + `/exportar-relatorio/${numeroContrato}`,
            lockScreen: false
        });
    },

    buscarDadosLoteEmpresa() {
        return http.get({
            url: URL_BASE + '/lote',
            lockScreen: false
        });
    },

    plantasEntregaBunge() {
        return http.get({
            url: '/plantas-entrega-bunge',
            lockScreen: false
        });
    },

    downloadPlanilhaComErro(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: URL_BASE + `/lote/download-planilha-erro/${id}`,
                    responseType: 'blob',
                    lockScreen: false
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },
    totalizadores({
        numeroContrato,
        idsMateriais,
        dataContratoInicio,
        dataContratoFim,
        idsCultura,
        idsSafra,
        codigosStatus,
        contratosComAlerta,
        idsCanais,
        idsSegmentos,
        idsRegionais,
        idsFornecedores,
        idsSubTradings
    }) {
        return http.post({
            url: URL_BASE + '/totalizadores',
            data: {
                numeroContrato,
                idsMateriais,
                dataContratoInicio,
                dataContratoFim,
                idsCultura,
                idsSafra,
                codigosStatus,
                contratosComAlerta,
                idsCanais,
                idsSegmentos,
                idsRegionais,
                idsFornecedores,
                idsSubTradings
            },
            lockScreen: false
        });
    },
    totalizadoresPY({
        numeroContrato,
        idsMateriais,
        dataContratoInicio,
        dataContratoFim,
        idsCultura,
        idsSafra,
        codigosStatus,
        contratosComAlerta,
        idsCanais,
        idsSegmentos,
        idsRegionais,
        idsFornecedores,
        idsSubTradings
    }) {
        return http.post({
            url: URL_BASE + '/totalizadores-py',
            data: {
                numeroContrato,
                idsMateriais,
                dataContratoInicio,
                dataContratoFim,
                idsCultura,
                idsSafra,
                codigosStatus,
                contratosComAlerta,
                idsCanais,
                idsSegmentos,
                idsRegionais,
                idsFornecedores,
                idsSubTradings
            },
            lockScreen: false
        });
    },
    statusSubEmpresa() {
        return http.get({
            url: URL_BASE + '/status',
            lockScreen: false
        });
    },
    contratos(dados, params) {
        return http.post({
            url:
                URL_BASE +
                `?page=${params.page}&size=${params.size}&sort=${params.sort},${params.por}`,
            data: dados,
            lockScreen: false
        });
    },
    contratosPY(dados, params) {
        return http.post({
            url:
                URL_BASE +
                '-py' +
                `?page=${params.page}&size=${params.size}&sort=${params.sort},${params.por}`,
            data: dados,
            lockScreen: false
        });
    },
    contratosAR(dados, params) {
        return http.post({
            url:
                URL_BASE +
                '-ar' +
                `?page=${params.page}&size=${params.size}&sort=${params.sort},${params.por}`,
            data: dados,
            lockScreen: false
        });
    },
    buscarContratoEdicao(id) {
        return http.get({
            url: URL_BASE + '/buscar-editar/' + id,
            lockScreen: false
        });
    },

    editarContrato(payload) {
        return http.post({
            url: URL_BASE + '/editar',
            data: { ...payload },
            lockScreen: false
        });
    },

    editarContratoPY(payload) {
        return http.post({
            url: URL_BASE + '/editar/paraguai',
            data: { ...payload },
            lockScreen: false
        });
    },

    editarContratoAR(payload) {
        return http.put({
            url: URL_BASE + '/ar/editar',
            data: { ...payload },
            lockScreen: false
        });
    },

    buscarTerritoriosAnalise(contratoOriginacao, params) {
        return http.get({
            url:
                URL_BASE +
                '/buscar-solicitacao/' +
                contratoOriginacao +
                `?page=${params.page}&size=${params.size}&sort=${params.sort},${params.por}`,
            lockScreen: true
        });
    },

    enviarRespostaAnalise({ idDadosContratoOriginacao, respostaAnalise }) {
        return http.post({
            url: URL_BASE + `/solicitacao/enviar-resposta`,
            data: {
                idDadosContratoOriginacao,
                respostaAnalise
            },
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.respostaAnaliseTerritorioContratos'
            )
        });
    },

    baixarLaudo(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: URL_BASE + `/laudo/parceria-sutentavel/download/${id}`,
                    responseType: 'blob',
                    lockScreen: false
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    exportarRelatorioXlsx(dados) {
        const fileLink = document.createElement('a');
        try {
            return http
                .post({
                    url: `${URL_BASE}/exportar-relatorio`,
                    data: dados,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t(
                        'mensagens.sistema.preparandoDadosParaDownload'
                    )
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    exportarRelatorioPYXlsx(dados) {
        const fileLink = document.createElement('a');
        try {
            return http
                .post({
                    url: `${URL_BASE}/exportar-relatorio-py`,
                    data: dados,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t(
                        'mensagens.sistema.preparandoDadosParaDownload'
                    )
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },
    exportarRelatorioARXlsx() {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: `exportarInformes/download`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t(
                        'mensagens.sistema.preparandoDadosParaDownload'
                    )
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    exportarInformesPY(idContratos) {
        const fileLink = document.createElement('a');
        try {
            return http.post({
                url: `${URL_BASE}/exportar-informes-py`,
                data: {
                    idContratos
                },
                responseType: 'blob',
                lockScreen: true,
                lockMessage: i18n.t(
                    'mensagens.sistema.preparandoDadosParaDownload'
                )
            }).then(response => {
                if (response.status === 200) {
                    const fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );

                    fileLink.href = fileURL;

                    const filenameRegex =
                        /filename=['"]?([^;\r\n"']*)['"]?;?/;
                    const contentDisposition =
                        response.headers['content-disposition'];

                    fileLink.setAttribute(
                        'download',
                        filenameRegex.exec(contentDisposition)[1]
                    );

                    document.body.appendChild(fileLink);
                    fileLink.click();
                }
            });
        } finally {
            fileLink.remove();
        }
    },

    buscarStatusSubempresa() {
        return http.get({
            url: URL_BASE + 'subempresa/status',
            lockScreen: false
        });
    },

    buscarContratosPorCar(codigoCar) {
        return http.get({
            url: URL_BASE + '/contratos/car/' + codigoCar,
            lockScreen: true
        });
    },

    buscarCamposNaoAtribuidos() {
        return http.get({
            url: URL_BASE + '/campos-nao-atribuidos',
            lockScreen: false
        });
    },

    buscarContratosNaoEnviadosAR({ pagina, ordenacao, tamanho }) {
        return http.get({
            url:
                URL_BASE +
                `/ar/nao-enviados?page=${
                    pagina - 1
                }&sort=${ordenacao}&size=${tamanho}`,
            lockScreen: false
        });
    }
};
